/* eslint-disable no-restricted-syntax */
// above disable is for the for..of

export const prepURLForFormatting = (
  url: string | Record<string, any>,
  state?: Record<string, any>,
  routerAsPath = '',
) => {
  if (typeof url === 'string') {
    return { pathname: url, state };
  }

  return {
    ...url,
    pathname: url?.pathname || routerAsPath.split('?')[0],
    state: url?.state || state,
    search: url?.search,
  };
};

const formatURLS = (url: string | Record<string, any>) => {
  if (typeof url === 'string') {
    return { href: url || '/', as: url || '/' };
  }

  // combine path and query params, adding '?' if needed
  const cleanedUrl =
    (url?.pathname || '') +
    (url?.search && url?.search?.[0] !== '?' ? '?' : '') +
    (url?.search || '');

  // ignore the base, required for URL constructor but we drop it on return.
  const trueParams = new URL(cleanedUrl, 'https://stockx.com');

  const visibleParams = new URL(cleanedUrl, 'https://stockx.com');

  if (url?.state) {
    for (const key of Object.keys(url?.state)) {
      trueParams.searchParams.append(key, url?.state[key]);
    }
  }

  return {
    href: {
      pathname: trueParams.pathname,
      search: trueParams.searchParams.toString(),
    },
    as: {
      pathname: visibleParams.pathname,
      search: visibleParams.searchParams.toString(),
    },
  };
};

export default formatURLS;
